import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as auth_actions from 'data/auth/actions'

import Field from 'components/Form/Field'
import Row from 'components/Form/Row'
import RaisedButton from 'material-ui/RaisedButton'
import Checkbox from 'material-ui/Checkbox'
import Dialog from 'material-ui/Dialog'
import Tos from 'components/Auth/Tos'

class RegistrationForm extends Component {
  state = {
    email: '',
    pw: '',
    pw2: '',
    tos: false,
    invite: false,
    invitehash: '',
    openTos: false,
    complete: false
  }

  handleSubmit = e => {
    e.preventDefault()

    this.setState(
      {
        email: this.email.state.value,
        phone: this.phone.state.value,
        pw: this.pw.state.value,
        pw2: this.pw2.state.value
      },
      this.updateComplete
    )
    this.props.actions.register(
      this.email.state.value,
      this.phone.state.value,
      this.pw.state.value
    )
  }

  handleFormUpdate = () => {
    this.setState(
      {
        ...this.state,
        email: this.email.state.value,
        phone: this.phone.state.value,
        pw: this.pw.state.value,
        pw2: this.pw2.state.value
      },
      this.updateComplete
    )
  }

  updateComplete = () => {
    console.log('updateComplete')
    var complete =
      this.state.email &&
      this.state.phone &&
      this.state.pw &&
      this.state.pw2 &&
      this.state.tos &&
      this.state.invitehash == '250286593' 
    this.setState({ ...this.state, complete })
  }

  tosChange = (e, v) => {
    console.log(e, v)
    this.setState({ ...this.state, tos: !this.state.tos }, this.updateComplete)
  }
  inviteChange = field => {
    var hash = this.hash(field.state.value.toLowerCase())
    console.log(field, hash)

    this.setState(
      { ...this.state, invite: field.state.value, invitehash: hash },
      this.updateComplete
    )
  }
  openTos = () => {
    console.log('open tos')
    this.setState(
      { ...this.state, openTos: !this.state.openTos },
      this.updateComplete
    )
  }

  hash = function(s) {
    var a = 1,
      c = 0,
      h,
      o
    if (s) {
      a = 0
      for (h = s.length - 1; h >= 0; h--) {
        o = s.charCodeAt(h)
        a = ((a << 6) & 268435455) + o + (o << 14)
        c = a & 266338304
        a = c !== 0 ? a ^ (c >> 21) : a
      }
    }
    return String(a)
  }

  render() {
    console.log(this.state)
    return (
      <form
        autoComplete="off"
        className="login_form"
        onSubmit={this.handleSubmit.bind(this)}
      >
        <Field
          value={this.state.email}
          ref={email => (this.email = email)}
          floatingLabelText="E-postadress"
          handleChange={this.handleFormUpdate}
        />
        <Field
          value={this.state.phone}
          ref={phone => (this.phone = phone)}
          floatingLabelText="Mobilnummer"
          handleChange={this.handleFormUpdate}
        />
        <div style={{ display: 'flex' }}>
          <Field
            value={this.state.pw}
            type="password"
            floatingLabelText="Lösenord"
            ref={pw => (this.pw = pw)}
            handleChange={this.handleFormUpdate}
          />
          <Field
            value={this.state.pw2}
            type="password"
            floatingLabelText="Bekräfta lösenord"
            ref={pw2 => (this.pw2 = pw2)}
            handleChange={this.handleFormUpdate}
          />
        </div>
        <Field
          value={this.state.invite}
          ref={invite => (this.invite = invite)}
          floatingLabelText="Verifieringskod"
          handleChange={this.inviteChange}
        />

        <Row>
          <div className="login_form__tos">
            <Checkbox
              label={
                <div>
                  Ja, jag godkänner{' '}
                  <a onClick={this.openTos}>användarvilkoren</a>.
                </div>
              }
              onCheck={this.tosChange}
              checked={this.state.tos}
            />
          </div>
        </Row>
        <Row>
          <RaisedButton
            primary={true}
            labelColor="#fff"
            type="submit"
            label="Registrera"
            disabled={!this.state.complete}
          />
        </Row>
        <Row>
          <span className="Padded">{this.props.children}</span>
        </Row>
        <p className="login_form__invite">
          Saknar du verifieringskod? Ansök genom att kontakta oss på{' '}
          <a href="mailto:konto@onestopmedia.se">konto@onestopmedia.se</a>.
        </p>
        <Dialog
          title="ANVÄNDARAVTAL"
          open={this.state.openTos}
          onRequestClose={this.openTos}
          autoScrollBodyContent={true}
        >
          <Tos />
        </Dialog>
      </form>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}
const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...auth_actions }, dispatch)
  }
}
export default connect(
  mapStateToProps,
  mapDispatch
)(RegistrationForm)



// WEBPACK FOOTER //
// ./src/components/Auth/RegistrationForm.jsx